export default __webpack_public_path__ + "static/WBTC-f3c8718835179e7543b572a206523377.png";